{
  "header": {
    "logoAlt": "MetaDevProfile",
    "brandName": "MetaDevProfile",
    "home": "Accueil",
    "contactUs": "Contactez-nous"
  },
  "signIn": {
    "title": "Bon retour",
    "description": "Connectez-vous à votre compte MetaDevProfile",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "********",
    "forgotPassword": "Mot de passe oublié ?",
    "signInButton": "Connexion",
    "noAccount": "Vous n'avez pas de compte ?",
    "signUpLink": "Inscription",
    "disclaimer": "En cliquant sur continuer, vous acceptez nos",
    "termsOfUse": "Conditions d'utilisation",
    "and": "et",
    "privacyPolicy": "Politique de confidentialité",
    "logoAlt": "Arrière-plan de connexion",
    "brandName": "MetaDevProfile",
    "testimonialAuthor": "Olivier Gorgy",
    "testimonialQuote": "MetaDevProfile a transformé la façon dont je gère ma pratique. L'interface est intuitive et les fonctionnalités sont exactement ce dont j'avais besoin.",
    "jobTitle": "Praticien libéral, Sensoted"
  },
  "signUp": {
    "title": "Créer un compte",
    "description": "Créez un compte pour commencer",
    "type": "Type",
    "typePractitioner": "Praticien",
    "typePractitionerDescription": "Vous réalisez des évaluations avec vos patients (compte individuel, application mobile)",
    "typeInstitution": "Institution",
    "typeInstitutionDescription": "Vous gérez une structure et créez des accès pour vos praticiens (pas d'évaluation depuis ce compte)",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "********",
    "passwordHint": "Min. 12 caractères, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial",
    "confirmPasswordPlaceholder": "********",
    "confirmPassword": "Confirmer le mot de passe",
    "signUpButton": "Inscription",
    "alreadyHaveAccount": "Vous avez déjà un compte ?",
    "signInLink": "Connexion",
    "disclaimer": "En cliquant sur continuer, vous acceptez nos",
    "termsOfUse": "Conditions d'utilisation",
    "and": "et",
    "privacyPolicy": "Politique de confidentialité",
    "logoAlt": "Arrière-plan d'inscription",
    "brandName": "MetaDevProfile",
    "testimonialAuthor": "Olivier Gorgy",
    "testimonialQuote": "MetaDevProfile a transformé la façon dont je gère ma pratique. L'interface est intuitive et les fonctionnalités sont exactement ce dont j'avais besoin.",
    "jobTitle": "Praticien libéral, Sensoted"
  },
  "forgotPassword": {
    "title": "Mot de passe oublié ?",
    "description": "Entrez votre email pour réinitialiser votre mot de passe",
    "email": "Email",
    "emailPlaceholder": "m@example.com",
    "sendButton": "Envoyer le lien de réinitialisation",
    "rememberPassword": "Vous vous souvenez de votre mot de passe ?",
    "signInLink": "Connexion"
  },
  "resetPassword": {
    "title": "Réinitialiser votre mot de passe",
    "description": "Entrez votre nouveau mot de passe ci-dessous",
    "password": "Nouveau mot de passe",
    "passwordHint": "Min. 12 caractères, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial",
    "confirmPassword": "Confirmer le nouveau mot de passe",
    "resetButton": "Réinitialiser le mot de passe",
    "rememberPassword": "Vous vous souvenez de votre mot de passe ?",
    "signInLink": "Connexion"
  },
  "verifyOtp": {
    "title": "Vérification en deux étapes",
    "description": "Un code de vérification a été envoyé à votre adresse email",
    "codeLabel": "Code de vérification",
    "codePlaceholder": "000000",
    "verifyButton": "Vérifier",
    "resendButton": "Renvoyer le code",
    "resendIn": "Renvoyer dans {{seconds}}s",
    "backToSignIn": "Retour à la connexion"
  },
  "errors": {
    "changePasswordFailed": "Échec du changement de mot de passe",
    "forgotPasswordFailed": "Échec de l'envoi de l'email de réinitialisation",
    "resetPasswordFailed": "Échec de la réinitialisation du mot de passe",
    "signInFailed": "Échec de la connexion",
    "accountLocked": "Compte temporairement verrouillé suite à trop de tentatives",
    "otpVerificationFailed": "Échec de la vérification du code",
    "otpResendFailed": "Échec du renvoi du code",
    "signUpFailed": "Échec de l'inscription",
    "signOutFailed": "Échec de la déconnexion",
    "fetchCurrentUserFailed": "Échec du chargement de l'utilisateur courant"
  },
  "success": {
    "signedOut": "Déconnexion réussie",
    "signedIn": "Connexion réussie",
    "signedUp": "Inscription réussie",
    "otpResent": "Un nouveau code de vérification a été envoyé",
    "forgotPasswordSent": "Si l'email existe, un lien de réinitialisation a été envoyé",
    "passwordReset": "Mot de passe réinitialisé avec succès",
    "passwordChanged": "Mot de passe changé avec succès"
  },
  "passwordCriteria": {
    "minLength": "12 caractères minimum",
    "lowercase": "1 lettre minuscule",
    "uppercase": "1 lettre majuscule",
    "digit": "1 chiffre",
    "specialChar": "1 caractère spécial"
  }
}
